'use strict';

import './_vendors/promise-polyfill';
import './_vendors/jquery';
import './_vendors/gsap/gsap';// new
import 'sharer.js';
import Cookies from 'js-cookie';

import './_modules/lazy-load';
import './_modules/mmenu';
import './_modules/mcusmoscrollbar';
import './_modules/buttons';
import './_modules/rating';
import './_modules/navpanel';
import './_modules/footer-tab';
import './_modules/inview';
import './_modules/load';
import './_modules/video';
import './_modules/time';
import horizontalScroll from './_modules/horizontal-scroll';
import wrapMedia from './_modules/wrap-media';
import validation from './_modules/validation';
import {mfpAjax, mfpIframe, mfpImage, mfpWysiwyg} from './_modules/magnific-popup';
import {trigger} from './_modules/trigger';
import phoneInput from './_modules/phone-input';
import locomotiveScroll from './_modules/locomotive-scroll';
import animate from './_modules/animate';
import sprite from './_modules/sprite';
import galleryInit from './_modules/lightgallery';
import textareaAutoResize from './_modules/textarea-auto-resize';
import tabs from './_modules/tabs';
import {bookInit} from './_modules/book';
import swiperInput from './_modules/swiper';
import faqAccordion from "#/_modules/faqAccordion";


// ----------------------------------------
// Public
// ----------------------------------------

window.jQuery(document).ready(($) => {
	const $windowScroll = $('[data-scroll-window]');
	if ($windowScroll.length) {
		import('./_modules/scroll-window').then(module => {
			module.default($windowScroll);
		});
	}
	horizontalScroll('.wysiwyg table');
	wrapMedia('.wysiwyg iframe, .wysiwyg video');
	validation('.js-form');
	mfpAjax('.js-mfp-ajax');
	mfpIframe('.js-mfp-iframe');
	mfpImage('.js-mfp-image');
	mfpWysiwyg('.wysiwyg');
	mfpWysiwyg('.js-footerTab');
	faqAccordion();
	swiperInput();
	trigger();
	phoneInput();
	locomotiveScroll();
	animate();
	sprite();
	galleryInit();
	setTtextareaAutoResize();
	tabs();
	bookInit();
});

$('.go-to-new-site__close').on('click', function () {
	$('.go-to-new-site').remove();
	Cookies.set('go-new-site', 1, {expires: 86400});
});

$(".attachment__input").change(function(){
	let filename = $(this).val().replace(/.*\\/, "");
	if (!filename.length) {
		$(".attachmen__text").html('Add an attachment');
	} else {
		$(".attachmen__text").html(filename);
	}
});

window.sss = function () {
	let now = new Date().getTime();
	let prevShow = window.localStorage.getItem('blog-popup');
	if (!prevShow || (Number(prevShow) + 24 * 60 * 60 * 1000) < now) {
		let pop = false;

		window.mgn = function () {
			pop = true;
			window.localStorage.setItem('blog-popup', now);

			$('.mybtns').trigger('click');
		};

		window.stm = function () {
			setInterval(function () {
				if (!pop) {
					window.mgn();
				}
			}, 15000);
		};

		window.stm();

		window.blogs = function () {
			document.addEventListener('mouseleave', function (e) {
				if (e.clientY < 0 && !pop) {
					window.mgn();
				}
			}, false);
		};

		window.blogs();
	}
};

var urlTNP = document.location.href;
var positionURL = urlTNP.indexOf('prodvizhenie_sajtov_za_rubezhom');

if (positionURL > 0) {
	window.sss();
}

function setTtextareaAutoResize () {
	$('textarea[data-form-input]').each(function () {
		const $control = $(this);
		textareaAutoResize($control);
		$control.on('input keyup paste change', () => {
			textareaAutoResize($control);
		});
	});
}

if (document.querySelector('.js-gmap')) {
	window.initMap = function () {
		require.ensure([], () => {
			require('_modules/map');
		}, 'gmap');
	};
}

if (document.querySelector('#telegram')) {
	let hulfHeight = $(document).height() / 2;

	$(document).scroll(function () {
		if ($(this).scrollTop() > hulfHeight) {
			$('#telegram').click().remove()
		}
	});
}

if (document.querySelector('#promote-score')) {
	setTimeout(() => {
		$('#promote-score').click();
	}, 40000)
}

const viewWebinarPopup = $('#viewPopupWebinar');
if (viewWebinarPopup.length) {
	setTimeout(() => {
		viewWebinarPopup.click();
	}, 10000);
}



// WEBPACK FOOTER //
// ./src/js/entry.js